export default __webpack_public_path__ + "static/media/oldPort.438578c9.png";